import { NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../Models/Enums/NotificationDuration';
import ForgotUsername from '../../Models/Security/ForgotUsername';
import { AppService, Types } from '../../Services/AppService';
import Home from '../Dashboard/Dashboard';

@NeoModel
export default class ForgotUsernameVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private securityApiClient = AppService.get(Types.ApiClients.SecurityApiClient),
        private navigation = AppService.get(Types.Neo.Routing.NavigationHelper)) {

        super(taskRunner);
    }

    public async initialise() { }

    public forgotUsername = new ForgotUsername() 

    public async SendUsername() {
        this.taskRunner.run("Sending username", async (opt) => {
            var response = await this.securityApiClient.forgotUsername(this.forgotUsername.toJSObject());
            if (response.data.success) {
                NotifyUtils.addSuccess("Username sent", "If the ID number corresponds with a user, an email containing your username has been sent to your email address.", NotificationDuration.Long);
                this.navigation.navigateToView(Home);
             }
        });
    }
}